export default "__VITE_ASSET__BIvn3ioz__"